import { Dispatch } from 'react';
import ActionTypes from '../ActionTypes';
import { GetNavDispatch } from '../../../components/sitePages/insurance/InsuranceNavStepper';
import {
  DealerHomepageOptions,
  DropdownData,
  InsuranceJourneyState,
  PaymentMethod
} from '../../../components/common/CommonTypes';

export const CommonPageEventHandlers = (dispatch: Dispatch<ActionTypes>) => {
  return {
    setCustomerSelfRegistration: (
      vendor: string,
      dealer: string,
      dealerOptions: DealerHomepageOptions
    ) => {
      dispatch({
        type: 'set-customer-self-registration',
        vendor: vendor,
        dealer: dealer,
        dealerHomeOptions: dealerOptions
      });
    },
    setSavingQuote: (flag: boolean) => {
      dispatch({
        type: 'set-saving-quote',
        savingQuote: flag
      });
    },
    onPageChange: (page: string, status: boolean) => {
      const action = GetNavDispatch(page, status);

      if (action !== undefined) {
        dispatch(action);
      }
    },
    setQuote: (quote: InsuranceJourneyState) => {
      dispatch({
        type: 'set-quote',
        quote
      });
    },
    setSelectedPaymentMethod: (paymentMethod: PaymentMethod) => {
      dispatch({
        type: 'set-payment-method',
        paymentMethod
      });
    },
    setStaticData: (data: DropdownData[]) => {
      dispatch({
        type: 'set-static-data',
        staticData: data
      });
    },
    setDealerHomepageOptions: (data: DealerHomepageOptions) => {
      dispatch({
        type: 'set-dealer-home-page-options',
        dealerHomepageOptions: data
      });
    },
    setDealerUsername: (dealerUsername: string) => {
      dispatch({
        type: 'set-dealer-username',
        dealerUsername
      });
    },
    setDealerRepresentative: (dealerRepresentative: string) => {
      dispatch({
        type: 'set-dealer-representative',
        dealerRepresentative
      });
    },
    setPageLoading: (flag: boolean) => {
      dispatch({
        type: 'set-page-loading',
        pageLoading: flag
      });
    }
  };
};
